import { ReactElement } from 'react';
import { Alert } from 'antd';

import { useRegionsAndBdms } from '@pmp/hooks';
import { getApiErrorMessage } from '@pmp/utils';

import { RegionPanel } from './RegionPanel';

export const LenderRegionsSection = (): ReactElement => {
  const { regions, bdms, loading, error, refresh } = useRegionsAndBdms();

  if (error && !regions.length && !bdms.length) return <Alert type="error" message={getApiErrorMessage(error)} />;

  return <RegionPanel regions={regions} bdms={bdms} loading={loading} refresh={refresh} />;
};
